import { http } from './client';
import { API_ROUTES } from './routes';

export interface IDashboardFilter {
  year?: number;
  month?: number;
}

export interface ICashTrendsResponse {
  cashBalance: number;
  monthlyBurnRate: number;
  burnRatePercent: number;
  cashRunwayMonths: number;
  netProfitMarginPercent: number;
  arVsApRatio: number;
  dso: number;
  runwayTrend: { name: string; runway: number }[];
}

export interface IProfitSpendResponse {
  netIncome: number;
  totalRevenueMtd: number;
  grossMarginPercent: number;
  yoyRevenueGrowthPercent: number;
  revenueProfitTrend: { name: string; grossProfit: number; netProfit: number; revenue: number }[];
  marginTrends: { name: string; grossMargin: number; netMargin: number }[];
}

export interface IMoneyInOutResponse {
  netAccountsReceivable: number;
  netAccountsPayable: number;
  dso: number;
  dpo: number;
  dsoDpoTrend: { name: string; dso: number; dpo: number }[];
}

export interface ICustomerSalesResponse {
  topCustomers: { customerName: string; revenue: number }[];
  customerConcentrationRisk: { top5Percent: number; othersPercent: number };
  newCustomerRevenue: number;
  existingCustomerRevenue: number;
  arpc: number;
  arpcTrend: { name: string; arpc: number }[];
}

export const dashboardApi = {
  getCashTrends: (companyId: string, filter?: IDashboardFilter): Promise<ICashTrendsResponse> =>
    http.get(API_ROUTES.dashboard.cashTrends(companyId), { params: filter }).then((r) => r.data),

  getProfitSpend: (companyId: string, filter?: IDashboardFilter): Promise<IProfitSpendResponse> =>
    http.get(API_ROUTES.dashboard.profitSpend(companyId), { params: filter }).then((r) => r.data),

  getMoneyInOut: (companyId: string, filter?: IDashboardFilter): Promise<IMoneyInOutResponse> =>
    http.get(API_ROUTES.dashboard.moneyInOut(companyId), { params: filter }).then((r) => r.data),

  getCustomerSales: (companyId: string, filter?: IDashboardFilter): Promise<ICustomerSalesResponse> =>
    http.get(API_ROUTES.dashboard.customerSales(companyId), { params: filter }).then((r) => r.data),
};
